import apiFetch from '../apiFetch'

export default function (fecha, token) {
  return apiFetch({endPoint: `Planning/getPlaningPorFecha`, method: 'POST', body: fecha, token: token})
}
